import React from 'react'
import styled, { ThemeProvider } from 'styled-components';

import theme from '~/theme';
import Spinner from '../spinner'
import Delayed from "../delayed";

const LoaderContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  
  > * {
    margin: 10px auto;
  }
`;

export default class PluginLoader extends React.PureComponent {
  render() {

    return <ThemeProvider theme={theme}><Delayed><LoaderContainer><Spinner radius={ 10 } strokeWidth={ 2 }/></LoaderContainer></Delayed></ThemeProvider>;
  }
}
